import React, { useState, useEffect } from 'react';
import { 
  Menu, X, ChevronRight, FileText, Download, Users, 
  Phone, Mail, MapPin, ArrowRight, Calendar, 
  MessageCircle, FileCheck, Layers, FileSignature, 
  Store, HeartHandshake, Briefcase, Sparkles, ShieldCheck,
  ArrowUpRight, Sun, Building
} from 'lucide-react';

export default function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isFloatingMenuOpen, setIsFloatingMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Efecto para cambiar el header al hacer scroll
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const primaryMenu = [
    { name: 'Inicio', id: '#inicio' },
    { name: 'Nosotros', id: '#nosotros' },
    { name: 'Trámites', id: '#tramites' },
    { name: 'Noticias', id: '#noticias' },
    { name: 'Transparencia', id: '#transparencia' },
  ];

  const secondaryMenu = [
    { name: 'Solicitudes', icon: <FileSignature size={18} />, href: '#tramites' },
    { name: 'Emprendedores', icon: <Store size={18} />, href: '#emprendedores' },
    { name: 'Formularios', icon: <FileText size={18} />, href: '#tramites' },
    { name: 'Actividades', icon: <Calendar size={18} />, href: '#noticias' },
    { name: 'Informes', icon: <FileCheck size={18} />, href: '#transparencia' },
  ];

  const noticias = [
    {
      id: 1,
      tag: "Comunidad",
      title: "Gran Jornada de Limpieza y Recuperación de Espacios Públicos en Mendoza",
      date: "15 Mayo, 2026",
      image: "https://images.unsplash.com/photo-1583521360098-b805408d6c70?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
      excerpt: "Vecinos, voluntarios y la Junta Comunal se unen para embellecer nuestras calles y parques principales en una jornada sin precedentes enfocada en la sostenibilidad y el trabajo en equipo."
    },
    {
      id: 2,
      tag: "Educación",
      title: "Nuevos cursos de capacitación para emprendedores locales",
      date: "10 Mayo, 2026",
      image: "https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      excerpt: "La Junta Comunal abre inscripciones para talleres gratuitos de marketing digital, contabilidad básica y atención al cliente."
    },
    {
      id: 3,
      tag: "Obras",
      title: "Avances en la pavimentación y luminarias del sector norte",
      date: "05 Mayo, 2026",
      image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      excerpt: "El proyecto de mejora vial avanza en su segunda fase, instalando más de 50 nuevas luminarias LED para mayor seguridad."
    },
    {
      id: 4,
      tag: "Salud",
      title: "Feria familiar y de salud preventiva comunitaria",
      date: "28 Abril, 2026",
      image: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      excerpt: "Más de 500 residentes se beneficiaron de atenciones médicas gratuitas, vacunación y asesoría nutricional."
    }
  ];

  const tramites = [
    { id: 1, title: "Permisos Comunitarios", icon: <Briefcase size={26} />, desc: "Solicitudes formales para el uso de espacios públicos, canchas y actividades barriales." },
    { id: 2, title: "Donaciones y Apoyos", icon: <HeartHandshake size={26} />, desc: "Asistencia social, deportiva y comunitaria directa para nuestros residentes vulnerables." },
    { id: 3, title: "Asesoría Legal", icon: <Users size={26} />, desc: "Orientación gratuita, mediación comunitaria y agendamiento rápido para atención." },
    { id: 4, title: "Certificaciones", icon: <ShieldCheck size={26} />, desc: "Emisión de certificados de residencia y validación de trámites vecinales generales." }
  ];

  const emprendedores = [
    { id: 1, name: "Fonda El Saborcito", community: "Sector Central", type: "Gastronomía", img: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" },
    { id: 2, name: "Confecciones Mendoza", community: "Vía Principal", type: "Costura", img: "https://images.unsplash.com/photo-1528698827591-e19ccd7bc23d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" },
    { id: 3, name: "Mini Super La Bendición", community: "Sector Norte", type: "Comercio", img: "https://images.unsplash.com/photo-1534723452862-4c874018d66d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" },
    { id: 4, name: "Panadería Dulce Hogar", community: "Plaza Central", type: "Panadería", img: "https://images.unsplash.com/photo-1509440159596-0249088772ff?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" }
  ];

  const documentosTransparencia = [
    { id: 1, title: "Presupuesto de Inversión 2026", type: "PDF", size: "2.4 MB" },
    { id: 2, title: "Planilla de Funcionarios - Q1", type: "Excel", size: "1.1 MB" },
    { id: 3, title: "Informe de Proyectos Comunitarios", type: "PDF", size: "3.5 MB" },
    { id: 4, title: "Actas de Reuniones del Concejo", type: "PDF", size: "5.0 MB" },
    { id: 5, title: "Solicitudes de Apoyo Aprobadas", type: "Excel", size: "800 KB" },
    { id: 6, title: "Auditoría Externa Anual 2025", type: "PDF", size: "4.2 MB" },
  ];

  // Nueva paleta de colores basada en los logos
  const colors = {
    primaryDark: '#0A2A43', // Azul oscuro del logo
    accentOrange: '#E67E22', // Naranja del banner
    accentGold: '#D4AF37',   // Dorado para detalles
    lightCream: '#F2EFE9',   // Fondo claro del escudo
    white: '#FFFFFF',
    slate: '#64748B'
  };

  return (
    <div className={`min-h-screen font-sans text-${colors.slate} overflow-x-hidden selection:bg-${colors.accentGold} selection:text-${colors.primaryDark} scroll-smooth`} style={{ backgroundColor: colors.lightCream }}>
      <style dangerouslySetInnerHTML={{__html: `
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        
        /* Glassmorphism Refinado */
        .glass-modern { 
          background: rgba(242, 239, 233, 0.65); /* Usando lightCream */
          backdrop-filter: blur(20px); 
          -webkit-backdrop-filter: blur(20px); 
          border: 1px solid rgba(255, 255, 255, 0.9); 
          box-shadow: 0 8px 32px rgba(10, 42, 67, 0.08); /* Usando primaryDark */
        }
        .glass-dark-modern { 
          background: rgba(10, 42, 67, 0.85); /* Usando primaryDark */
          backdrop-filter: blur(24px); 
          -webkit-backdrop-filter: blur(24px); 
          border-bottom: 1px solid rgba(255, 255, 255, 0.1); 
        }
        
        /* Franjas / Stripes Effect */
        .stripes-pattern {
          background-image: repeating-linear-gradient(
            45deg,
            rgba(255, 255, 255, 0.05) 0px,
            rgba(255, 255, 255, 0.05) 2px,
            transparent 2px,
            transparent 8px
          );
        }
        .stripes-dark {
          background-image: repeating-linear-gradient(
            -45deg,
            rgba(0, 0, 0, 0.03) 0px,
            rgba(0, 0, 0, 0.03) 2px,
            transparent 2px,
            transparent 8px
          );
        }

        /* Elevaciones Fluidas */
        .card-elevate {
          transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
        }
        .card-elevate:hover {
          transform: translateY(-8px);
          box-shadow: 0 24px 48px rgba(10, 42, 67, 0.12), 0 4px 12px rgba(230, 126, 34, 0.1); /* Usando primaryDark y accentOrange */
        }

        /* Micro-Animaciones */
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(2deg); }
        }
        .animate-float { animation: float 8s ease-in-out infinite; }
        
        @keyframes pulse-glow {
          0%, 100% { opacity: 0.4; transform: scale(1); }
          50% { opacity: 0.7; transform: scale(1.05); }
        }
        .animate-glow { animation: pulse-glow 6s ease-in-out infinite; }
        
        /* FAB Spring Animation */
        .fab-item {
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          opacity: 0;
          transform: translateY(20px) scale(0.8);
        }
        .fab-open .fab-item {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
        .fab-item:nth-child(1) { transition-delay: 0.05s; }
        .fab-item:nth-child(2) { transition-delay: 0.10s; }
        .fab-item:nth-child(3) { transition-delay: 0.15s; }
        .fab-item:nth-child(4) { transition-delay: 0.20s; }
        .fab-item:nth-child(5) { transition-delay: 0.25s; }
      `}} />

      {/* Franja superior institucional (Azul, Dorado, Naranja) */}
      <div className="h-2 w-full flex relative z-50">
        <div className="w-1/3 stripes-pattern" style={{ backgroundColor: colors.primaryDark }}></div>
        <div className="w-1/3 stripes-pattern" style={{ backgroundColor: colors.accentGold }}></div>
        <div className="w-1/3 stripes-pattern" style={{ backgroundColor: colors.accentOrange }}></div>
      </div>

      {/* Header Fijo */}
      <header className={`fixed w-full z-40 transition-all duration-500 ${scrolled ? 'top-0 glass-dark-modern shadow-[0_10px_30px_rgba(0,0,0,0.2)] py-2' : 'top-2 bg-transparent py-4'} text-white`}>
        <div className="absolute inset-0 stripes-pattern opacity-50 pointer-events-none"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="flex justify-between items-center h-16">
            
            {/* Logo Generado con CSS/Iconos */}
            <div className="flex-shrink-0 flex items-center gap-4 cursor-pointer group">
              <div className="h-12 w-12 rounded-full overflow-hidden border-2 border-[#FFB703] shadow-[0_0_20px_rgba(255,183,3,0.5)] group-hover:scale-105 transition-all duration-300 bg-gradient-to-br from-[#0A2A43] to-[#E67E22] flex items-center justify-center relative">
                <div className="absolute inset-0 stripes-pattern opacity-30"></div>
                <Sun size={26} className="text-[#FFB703] absolute -top-1 -right-1 opacity-60 animate-pulse" />
                <Building size={22} className="text-white relative z-10 drop-shadow-md mt-2" />
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-sm lg:text-base leading-tight uppercase tracking-wider text-slate-200">Junta Comunal</span>
                <span className="font-extrabold text-xl lg:text-2xl leading-tight text-[#FFB703] tracking-widest drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]">Mendoza</span>
              </div>
            </div>

            {/* Menu Desktop */}
            <nav className="hidden lg:flex space-x-8 items-center">
              {primaryMenu.map((item) => (
                <a key={item.name} href={item.id} className="text-sm font-semibold hover:text-[#D4AF37] transition-colors relative group tracking-wide">
                  {item.name}
                  <span className="absolute -bottom-1.5 left-0 w-0 h-0.5 bg-gradient-to-r from-[#D4AF37] to-[#E67E22] transition-all duration-300 group-hover:w-full rounded-full shadow-[0_0_8px_rgba(212,175,55,0.8)]"></span>
                </a>
              ))}
              <a href="#contacto" className="ml-4 px-7 py-2.5 rounded-full bg-gradient-to-r from-[#E67E22] to-[#D35400] hover:from-[#D35400] hover:to-[#E67E22] border border-white/20 backdrop-blur text-sm font-bold transition-all duration-300 flex items-center gap-2 shadow-[0_4px_15px_rgba(230,126,34,0.4)] hover:shadow-[0_6px_20px_rgba(230,126,34,0.6)]">
                Contáctenos
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <div className="lg:hidden flex items-center">
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-[#D4AF37] hover:text-white transition-colors bg-white/10 p-2 rounded-lg backdrop-blur-md border border-white/20">
                {isMobileMenuOpen ? <X size={26} /> : <Menu size={26} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu Panel */}
        {isMobileMenuOpen && (
          <div className="lg:hidden glass-dark-modern border-t border-white/10 absolute w-full left-0 shadow-2xl mt-1">
            <div className="px-4 pt-4 pb-6 space-y-3 relative z-10">
              {primaryMenu.map((item) => (
                <a key={item.name} href={item.id} onClick={() => setIsMobileMenuOpen(false)} className="block px-4 py-3 text-base font-semibold text-white hover:bg-white/10 hover:text-[#D4AF37] rounded-xl transition-colors border border-transparent hover:border-white/10">
                  {item.name}
                </a>
              ))}
              <a href="#contacto" onClick={() => setIsMobileMenuOpen(false)} className="block w-full text-center mt-4 px-4 py-3 rounded-xl bg-gradient-to-r from-[#E67E22] to-[#D35400] text-white font-bold shadow-lg border border-orange-400/30">
                Contáctenos
              </a>
            </div>
          </div>
        )}
      </header>

      {/* Floating Secondary Menu (FAB) Premium */}
      <div className="fixed bottom-6 right-6 lg:bottom-8 lg:right-8 z-50 flex flex-col items-end">
        {/* Menu Items */}
        <div className={`flex flex-col gap-3 mb-4 origin-bottom-right transition-all duration-300 ${isFloatingMenuOpen ? 'fab-open pointer-events-auto opacity-100 scale-100 translate-y-0' : 'pointer-events-none opacity-0 scale-95 translate-y-4'}`}>
          <div className="glass-modern p-3.5 rounded-3xl shadow-[0_15px_40px_rgba(10,42,67,0.15)] border border-white/80 flex flex-col gap-2">
            {secondaryMenu.map((item, index) => (
              <a key={index} href={item.href} onClick={() => setIsFloatingMenuOpen(false)} className="fab-item flex items-center gap-3.5 bg-transparent px-5 py-3 rounded-2xl transition-all font-bold text-sm group border border-transparent hover:border-slate-200" style={{ color: colors.primaryDark, backgroundColor: colors.lightCream }}>
                <span className="group-hover:scale-110 transition-transform bg-white group-hover:bg-[#D4AF37]/10 p-2 rounded-xl shadow-sm" style={{ color: colors.accentOrange }}>
                  {item.icon}
                </span>
                {item.name}
              </a>
            ))}
          </div>
        </div>
        
        {/* Main Floating Button */}
        <button 
          onClick={() => setIsFloatingMenuOpen(!isFloatingMenuOpen)}
          className={`h-16 w-16 rounded-full flex items-center justify-center text-white shadow-[0_10px_25px_rgba(10,42,67,0.4)] transition-all duration-500 z-50 border border-white/20 ${isFloatingMenuOpen ? 'rotate-45 scale-105 shadow-[0_15px_35px_rgba(230,126,34,0.5)]' : 'hover:scale-110 hover:shadow-[0_15px_35px_rgba(10,42,67,0.6)]'}`}
          style={{ background: isFloatingMenuOpen ? `linear-gradient(to bottom right, ${colors.accentOrange}, #D35400)` : `linear-gradient(to bottom right, ${colors.primaryDark}, #0d3a5c)` }}
        >
          {isFloatingMenuOpen ? <X size={26} /> : <Layers size={26} />}
        </button>
      </div>

      {/* Hero Section Refinada con Iluminación y Transparencia Específica */}
      <section id="inicio" className="relative pt-32 pb-24 lg:pt-48 lg:pb-40 overflow-hidden" style={{ backgroundColor: '#020E1A' }}>
        {/* Background Image & Premium Gradient Overlay */}
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1544644181-1484b3fdfc62?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" 
            alt="Comunidad Mendoza" 
            className="w-full h-full object-cover opacity-80"
          />
          {/* Capas de degradado sutil para asegurar lectura sin tapar la imagen */}
          <div className="absolute inset-0 bg-gradient-to-b from-[#020E1A]/60 via-transparent to-[#020E1A]/90"></div>
          <div className="absolute inset-0 stripes-pattern opacity-30"></div>
          
          {/* Subtle noise texture */}
          <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.65%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")' }}></div>
        </div>

        {/* Efectos de Iluminación Volumétrica (Glows / Blurs Sutiles) */}
        <div className="absolute top-1/4 -left-32 w-[40rem] h-[40rem] rounded-full mix-blend-screen filter blur-[120px] opacity-60 animate-glow" style={{ backgroundColor: colors.primaryDark }}></div>
        <div className="absolute bottom-10 right-0 w-[35rem] h-[35rem] rounded-full mix-blend-screen filter blur-[150px] opacity-40 animate-float" style={{ backgroundColor: colors.accentOrange }}></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[30rem] h-[30rem] rounded-full mix-blend-screen filter blur-[160px] opacity-20 pointer-events-none" style={{ backgroundColor: colors.accentGold }}></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10 pt-10">
          
          {/* CONTENEDOR HERO CON TRANSPARENCIA (Glassmorphism) SOLICITADO */}
          <div className="max-w-3xl glass-modern p-8 md:p-12 rounded-[2.5rem] md:rounded-[3.5rem] border border-white/20 shadow-[0_20px_50px_rgba(0,0,0,0.3)] backdrop-blur-xl relative overflow-hidden" style={{ backgroundColor: 'rgba(10, 42, 67, 0.4)' }}>
            {/* Brillo interno decorativo del contenedor */}
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-white/10 to-transparent pointer-events-none"></div>
            
            <div className="relative z-10 text-white">
              <span className="inline-flex items-center gap-2 py-1.5 px-5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-xs sm:text-sm font-bold tracking-widest text-[#D4AF37] mb-8 shadow-[0_0_15px_rgba(212,175,55,0.2)]">
                <Sparkles size={16} className="text-[#E67E22]" />
                UNIDOS POR MENDOZA
              </span>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-[1.15] drop-shadow-xl">
                Trabajemos juntos <br/> por un futuro <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] via-[#FDE047] to-[#E67E22] drop-shadow-sm">brillante</span>.
              </h1>
              
              <p className="text-lg md:text-xl text-slate-200 mb-10 max-w-2xl font-light leading-relaxed drop-shadow-md">
                Impulsamos el desarrollo social, vecinal y urbano de nuestro corregimiento, siempre al servicio directo de nuestra comunidad.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-5">
                <a href="#tramites" className="bg-gradient-to-r from-[#E67E22] to-[#D35400] hover:from-[#D35400] hover:to-[#E67E22] text-white px-8 py-4.5 rounded-2xl font-bold transition-all shadow-[0_8px_25px_rgba(230,126,34,0.4)] hover:shadow-[0_12px_35px_rgba(230,126,34,0.6)] hover:-translate-y-1.5 flex items-center justify-center gap-2 text-lg border border-orange-400/30">
                  Realizar Trámite <ArrowRight size={20} />
                </a>
                <a href="#noticias" className="bg-white/10 hover:bg-white/20 backdrop-blur-md text-white px-8 py-4.5 rounded-2xl font-bold transition-all flex items-center justify-center gap-2 text-lg hover:-translate-y-1.5 shadow-lg border border-white/30">
                  Últimas Noticias
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Franja decorativa inferior suave con wave */}
        <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none z-20">
          <svg className="relative block w-full h-12 md:h-20" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" className="fill-[#0A2A43]/5"></path>
            <path d="M0 120L1200 120 1200 0 0 120z" style={{ fill: colors.lightCream }}></path>
          </svg>
        </div>
      </section>

      {/* Sección Nosotros / Representante */}
      <section id="nosotros" className="py-28 relative overflow-hidden" style={{ backgroundColor: colors.lightCream }}>
        {/* Franjas decorativas sutiles de fondo */}
        <div className="absolute top-0 right-0 w-1/2 h-full stripes-dark opacity-40 pointer-events-none"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="flex flex-col lg:flex-row gap-16 items-center">
            
            {/* Foto Representante (Elevada con glow) */}
            <div className="lg:w-5/12 relative w-full max-w-md mx-auto lg:mx-0">
              <div className="absolute -top-6 -left-6 w-full h-full border-[3px] rounded-[2.5rem] z-0" style={{ borderColor: 'rgba(212, 175, 55, 0.4)' }}></div>
              <div className="absolute -bottom-8 -right-8 w-3/4 h-3/4 bg-gradient-to-br from-[#0A2A43] to-[#E67E22] rounded-[2.5rem] z-0 opacity-20 animate-float filter blur-[15px]"></div>
              
              <div className="relative z-10 rounded-[2.5rem] overflow-hidden shadow-[0_25px_60px_rgba(10,42,67,0.2)] aspect-[4/5] bg-slate-200 group border-4 border-white">
                <img 
                  src="https://images.unsplash.com/photo-1556157382-97eda2d62296?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                  alt="H.R. Ismael Martínez" 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A2A43] via-[#0A2A43]/40 to-transparent opacity-90 mix-blend-multiply"></div>
                <div className="absolute bottom-0 left-0 w-full p-8 pt-20">
                  <h3 className="text-3xl font-extrabold text-white mb-1 drop-shadow-md">H.R. Ismael Martínez</h3>
                  <p className="font-bold tracking-wide uppercase text-sm flex items-center gap-2 drop-shadow" style={{ color: colors.accentGold }}>
                    <ShieldCheck size={16} /> Junta Comunal de Mendoza
                  </p>
                </div>
              </div>
            </div>

            {/* Info y Contacto */}
            <div className="lg:w-7/12 relative">
              {/* Blur sutil decorativo */}
              <div className="absolute top-10 left-20 w-40 h-40 rounded-full filter blur-[80px] opacity-20 pointer-events-none" style={{ backgroundColor: colors.accentGold }}></div>

              <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full glass-modern font-bold text-sm mb-6 border shadow-sm" style={{ color: colors.accentOrange, borderColor: 'rgba(230, 126, 34, 0.2)' }}>
                <Users size={16} /> Nuestra Gestión
              </div>
              <h2 className="text-4xl md:text-5xl font-extrabold mb-6 leading-tight drop-shadow-sm" style={{ color: colors.primaryDark }}>
                Compromiso con la historia y el progreso de Mendoza.
              </h2>
              <p className="text-slate-600 mb-10 text-lg leading-relaxed font-medium">
                La Junta Comunal de Mendoza trabaja incansablemente para garantizar el bienestar de sus residentes, mejorar la infraestructura local y fomentar un entorno seguro y próspero para nuestras familias y el comercio de la zona.
              </p>

              <div className="grid sm:grid-cols-2 gap-6">
                <div className="glass-modern p-6 rounded-3xl border border-white shadow-lg card-elevate flex items-start gap-5 group cursor-default">
                  <div className="p-4 rounded-2xl transition-all shadow-inner group-hover:text-white" style={{ backgroundColor: 'rgba(10, 42, 67, 0.1)', color: colors.primaryDark }}>
                    <Phone size={24} />
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-800 text-sm uppercase tracking-wider mb-1">Teléfonos</h4>
                    <p className="font-extrabold text-lg" style={{ color: colors.primaryDark }}>200-0000 <br/> 200-0001</p>
                  </div>
                </div>
                <div className="glass-modern p-6 rounded-3xl border border-white shadow-lg card-elevate flex items-start gap-5 group cursor-default">
                  <div className="p-4 rounded-2xl transition-all shadow-inner group-hover:text-white" style={{ backgroundColor: 'rgba(230, 126, 34, 0.1)', color: colors.accentOrange }}>
                    <Mail size={24} />
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-800 text-sm uppercase tracking-wider mb-1">Correo</h4>
                    <p className="font-bold break-all leading-tight" style={{ color: colors.accentOrange }}>jcmendoza@gmail.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN: Solicitudes y Trámites */}
      <section id="tramites" className="py-28 relative bg-white border-y border-slate-100 overflow-hidden">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#D4AF37]/10 via-transparent to-transparent opacity-80 pointer-events-none filter blur-[50px]"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#0A2A43]/5 via-transparent to-transparent opacity-80 pointer-events-none filter blur-[50px]"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <div className="inline-flex items-center justify-center gap-2 px-5 py-2 rounded-full font-bold text-sm mb-4 border backdrop-blur-sm shadow-sm" style={{ backgroundColor: 'rgba(10, 42, 67, 0.05)', color: colors.primaryDark, borderColor: 'rgba(10, 42, 67, 0.1)' }}>
              <FileSignature size={16} style={{ color: colors.accentOrange }} /> Servicios Comunitarios
            </div>
            <h2 className="text-4xl md:text-5xl font-extrabold mb-6 drop-shadow-sm" style={{ color: colors.primaryDark }}>Solicitudes y Trámites</h2>
            <p className="text-slate-600 text-lg font-medium">
              Gestiona tus permisos, solicitudes de apoyo y más de forma rápida, transparente y directa con tu Junta Comunal.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {tramites.map((tramite) => (
              <div key={tramite.id} className="bg-[#F2EFE9] border border-white rounded-[2rem] p-8 card-elevate group cursor-pointer relative overflow-hidden flex flex-col h-full shadow-[0_10px_30px_rgba(0,0,0,0.03)]">
                {/* Degradado/Franja decorativa on hover */}
                <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-br from-[#D4AF37]/5 to-[#E67E22]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 stripes-pattern"></div>
                
                <div className="relative h-16 w-16 bg-white shadow-md rounded-2xl flex items-center justify-center mb-6 group-hover:bg-gradient-to-br group-hover:from-[#E67E22] group-hover:to-[#D35400] group-hover:text-white group-hover:shadow-[0_8px_20px_rgba(230,126,34,0.3)] transition-all duration-300 border border-slate-100 z-10" style={{ color: colors.primaryDark }}>
                  {tramite.icon}
                </div>
                <h3 className="relative text-xl font-bold mb-3 leading-tight z-10" style={{ color: colors.primaryDark }}>{tramite.title}</h3>
                <p className="relative text-slate-600 text-sm mb-8 leading-relaxed flex-grow z-10 font-medium">{tramite.desc}</p>
                
                <div className="relative mt-auto flex items-center font-bold text-sm group-hover:text-[#D35400] z-10 bg-white/60 w-fit px-4 py-2 rounded-xl border border-transparent group-hover:border-orange-100" style={{ color: colors.accentOrange }}>
                  Realizar solicitud <ArrowRight size={16} className="ml-2 transform group-hover:translate-x-1.5 transition-transform" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECCIÓN: Emprendedores */}
      <section id="emprendedores" className="py-28 relative text-white overflow-hidden border-t-4" style={{ backgroundColor: colors.primaryDark, borderColor: colors.accentGold }}>
        {/* Fondo oscuro premium con franjas y transparencias */}
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1556761175-5973dc0f32d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')] mix-blend-overlay opacity-[0.15] object-cover"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A2A43] via-transparent to-[#020E1A]"></div>
        <div className="absolute inset-0 stripes-pattern opacity-30"></div>
        
        {/* Glows */}
        <div className="absolute top-1/2 right-1/4 w-96 h-96 rounded-full filter blur-[150px] opacity-25 pointer-events-none" style={{ backgroundColor: colors.accentOrange }}></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="flex flex-col lg:flex-row justify-between items-end mb-16 gap-8">
            <div className="max-w-2xl">
              <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full glass-modern !bg-white/10 font-bold text-sm mb-4 border border-white/20 shadow-sm" style={{ color: colors.accentGold }}>
                <Store size={16} /> Economía Local
              </div>
              <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-4 drop-shadow-md">Directorio de Emprendedores</h2>
              <p className="text-slate-300 text-lg font-light">Apoyamos el talento local. Descubre y fomenta el crecimiento de los pequeños negocios que dan vida a Mendoza.</p>
            </div>
            <button className="bg-gradient-to-r from-[#D4AF37] to-[#FDE047] hover:from-[#FDE047] hover:to-[#D4AF37] px-8 py-4 rounded-2xl font-bold transition-all shadow-[0_8px_25px_rgba(212,175,55,0.3)] hover:shadow-[0_12px_35px_rgba(212,175,55,0.5)] hover:-translate-y-1 whitespace-nowrap flex items-center gap-2 text-lg border border-yellow-300/50" style={{ color: colors.primaryDark }}>
              Registrar mi negocio <ArrowUpRight size={20} />
            </button>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {emprendedores.map((emp) => (
              <div key={emp.id} className="glass-dark-modern rounded-3xl overflow-hidden group cursor-pointer hover:-translate-y-2 transition-all duration-400 border border-white/10 hover:border-[#D4AF37]/50 shadow-[0_15px_30px_rgba(0,0,0,0.3)] relative">
                {/* Highlight superior on hover */}
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent opacity-0 group-hover:opacity-100 transition-opacity z-20"></div>
                
                <div className="h-56 overflow-hidden relative">
                  <div className="absolute top-4 right-4 z-10 glass-modern !bg-black/50 text-xs font-bold px-3 py-1.5 rounded-full border border-white/20 shadow-sm backdrop-blur-md" style={{ color: colors.accentGold }}>
                    {emp.type}
                  </div>
                  <img src={emp.img} alt={emp.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A2A43] via-[#0A2A43]/60 to-transparent opacity-90 mix-blend-multiply"></div>
                </div>
                <div className="p-6 relative -mt-6 bg-gradient-to-b from-transparent to-[#0A2A43]/50">
                  <h3 className="font-bold text-xl text-white mb-2 group-hover:text-[#D4AF37] transition-colors drop-shadow">{emp.name}</h3>
                  <div className="flex items-center gap-2 text-slate-300 text-sm font-medium">
                    <MapPin size={16} style={{ color: colors.accentOrange }} /> {emp.community}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sección Noticias (Grid Premium) */}
      <section id="noticias" className="py-28 relative overflow-hidden" style={{ backgroundColor: colors.lightCream }}>
        <div className="absolute top-0 left-0 w-full h-4 bg-gradient-to-b from-[#0A2A43]/5 to-transparent"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
            <div>
              <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full glass-modern font-bold text-sm mb-4 border shadow-sm" style={{ color: colors.primaryDark, borderColor: 'rgba(10, 42, 67, 0.2)' }}>
                <MessageCircle size={16} style={{ color: colors.accentOrange }} /> Mantente Informado
              </div>
              <h2 className="text-4xl md:text-5xl font-extrabold drop-shadow-sm" style={{ color: colors.primaryDark }}>Noticias y Comunicados</h2>
            </div>
            <button className="bg-white border-2 px-8 py-4 rounded-2xl font-bold transition-all shadow-[0_5px_15px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_25px_rgba(10,42,67,0.3)] flex items-center gap-2 group text-lg" style={{ color: colors.primaryDark, borderColor: colors.primaryDark }}>
              Ver todas las noticias <ArrowRight size={20} className="group-hover:translate-x-1.5 transition-transform" />
            </button>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            {/* Noticia Destacada (Featured) */}
            <div className="lg:col-span-7 group cursor-pointer card-elevate">
              <div className="relative rounded-[2.5rem] overflow-hidden shadow-[0_15px_40px_rgba(0,0,0,0.08)] h-full min-h-[480px] border-4 border-white">
                <img src={noticias[0].image} alt={noticias[0].title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#020E1A] via-[#0A2A43]/50 to-transparent opacity-95 mix-blend-multiply"></div>
                <div className="absolute inset-0 stripes-pattern opacity-20 pointer-events-none"></div>
                
                <div className="absolute top-8 left-8 z-10 glass-modern !bg-white/20 text-white text-xs font-extrabold uppercase tracking-widest px-5 py-2 rounded-full shadow-lg border border-white/40 backdrop-blur-md">
                  {noticias[0].tag}
                </div>
                
                <div className="absolute bottom-0 left-0 w-full p-8 md:p-12">
                  <p className="font-bold text-sm mb-4 flex items-center gap-2 glass-modern !bg-black/30 w-fit px-4 py-2 rounded-full border border-white/10" style={{ color: colors.accentGold }}>
                    <Calendar size={14} /> {noticias[0].date}
                  </p>
                  <h3 className="font-extrabold text-3xl md:text-4xl text-white mb-5 leading-tight group-hover:text-[#D4AF37] transition-colors drop-shadow-lg">{noticias[0].title}</h3>
                  <p className="text-slate-200 text-base md:text-lg mb-0 line-clamp-3 md:line-clamp-none font-medium leading-relaxed drop-shadow">{noticias[0].excerpt}</p>
                </div>
              </div>
            </div>

            {/* Cuadrícula de otras noticias */}
            <div className="lg:col-span-5 flex flex-col gap-6">
              {noticias.slice(1).map((noticia) => (
                <div key={noticia.id} className="glass-modern !bg-white/90 rounded-3xl overflow-hidden shadow-[0_8px_25px_rgba(0,0,0,0.04)] border border-white card-elevate group flex flex-col sm:flex-row h-full cursor-pointer relative">
                  {/* Hover accent line */}
                  <div className="absolute left-0 top-0 w-1 h-full scale-y-0 group-hover:scale-y-100 transition-transform origin-top z-20" style={{ backgroundColor: colors.accentOrange }}></div>

                  <div className="sm:w-2/5 relative overflow-hidden min-h-[180px]">
                    <div className="absolute top-4 left-4 z-10 glass-modern !bg-white/90 text-[10px] font-extrabold uppercase px-3 py-1.5 rounded-full shadow-sm" style={{ color: colors.primaryDark }}>
                      {noticia.tag}
                    </div>
                    <img src={noticia.image} alt={noticia.title} className="w-full h-full object-cover absolute inset-0 group-hover:scale-110 transition-transform duration-700" />
                    <div className="absolute inset-0 bg-[#0A2A43]/10 group-hover:bg-transparent transition-colors mix-blend-multiply"></div>
                  </div>
                  <div className="p-6 sm:w-3/5 flex flex-col justify-center">
                    <p className="text-xs font-bold mb-3 flex items-center gap-1.5" style={{ color: colors.accentOrange }}><Calendar size={14}/> {noticia.date}</p>
                    <h3 className="font-bold text-lg mb-3 line-clamp-2 group-hover:text-[#E67E22] transition-colors leading-snug drop-shadow-sm" style={{ color: colors.primaryDark }}>{noticia.title}</h3>
                    <p className="text-slate-500 text-sm line-clamp-2 mb-5 leading-relaxed font-medium">{noticia.excerpt}</p>
                    <span className="font-bold text-sm inline-flex items-center gap-1.5 group-hover:text-[#D4AF37] transition-colors mt-auto uppercase tracking-wide" style={{ color: colors.primaryDark }}>
                      Leer más <ArrowRight size={16} className="transform group-hover:translate-x-1 transition-transform" />
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Sección Transparencia (Refinada Premium) */}
      <section id="transparencia" className="py-28 relative overflow-hidden" style={{ backgroundColor: '#020E1A' }}>
        {/* Patrón premium, franjas y blurs */}
        <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'radial-gradient(#ffffff 2px, transparent 2px)', backgroundSize: '32px 32px' }}></div>
        <div className="absolute inset-0 stripes-pattern opacity-20"></div>
        <div className="absolute -top-40 -right-40 w-[50rem] h-[50rem] rounded-full filter blur-[180px] opacity-15" style={{ backgroundColor: colors.accentGold }}></div>
        <div className="absolute -bottom-40 -left-40 w-[40rem] h-[40rem] rounded-full filter blur-[180px] opacity-15" style={{ backgroundColor: colors.accentOrange }}></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <div className="inline-flex items-center justify-center gap-2 px-5 py-2 rounded-full glass-modern !bg-white/10 text-white font-bold text-sm mb-4 border border-white/20 backdrop-blur-sm shadow-sm">
              <ShieldCheck size={16} className="text-[#D4AF37]" /> Dominio Público
            </div>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6 drop-shadow-md">Portal de Transparencia</h2>
            <p className="text-slate-300 text-lg font-light">
              Comprometidos con la rendición de cuentas. Accede libremente a los documentos de gestión, presupuestos e informes de la Junta Comunal.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {documentosTransparencia.map((doc) => (
              <div key={doc.id} className="glass-dark-modern rounded-[2rem] p-6 hover:bg-white/10 transition-all duration-400 group cursor-pointer border border-white/10 hover:border-[#D4AF37]/40 shadow-[0_10px_30px_rgba(0,0,0,0.2)] hover:-translate-y-1.5 relative overflow-hidden">
                {/* Glow decorativo on hover */}
                <div className="absolute -bottom-10 -right-10 w-32 h-32 rounded-full opacity-0 group-hover:opacity-20 filter blur-[30px] transition-opacity duration-500" style={{ backgroundColor: colors.accentGold }}></div>

                <div className="flex items-start gap-5 relative z-10">
                  <div className="p-4 rounded-2xl group-hover:bg-gradient-to-br group-hover:from-[#D4AF37] group-hover:to-[#cca300] group-hover:text-[#0A2A43] transition-all shadow-sm border" style={{ backgroundColor: 'rgba(212, 175, 55, 0.2)', color: colors.accentGold, borderColor: 'rgba(212, 175, 55, 0.3)' }}>
                    <FileText size={24} />
                  </div>
                  <div className="flex-1">
                    <h4 className="font-bold text-white text-base mb-2 leading-tight group-hover:text-[#D4AF37] transition-colors drop-shadow-sm">{doc.title}</h4>
                    <div className="flex items-center gap-3 text-xs text-slate-300 font-semibold">
                      <span className="glass-modern !bg-white/10 px-3 py-1 rounded-md text-white border border-white/20">{doc.type}</span>
                      <span>{doc.size}</span>
                    </div>
                  </div>
                  <button className="text-slate-400 hover:text-white transition-colors p-2 glass-modern !bg-white/5 rounded-full group-hover:!bg-[#E67E22] group-hover:border-orange-400/50 shadow-sm">
                    <Download size={18} />
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-20 text-center relative z-10">
            <button className="glass-modern !bg-white/10 text-white px-10 py-4.5 rounded-2xl font-bold transition-all shadow-[0_8px_20px_rgba(0,0,0,0.2)] hover:shadow-[0_12px_30px_rgba(0,0,0,0.3)] hover:-translate-y-1 inline-flex items-center gap-2 text-lg border border-white/30 hover:bg-white/20 hover:border-white/50">
              Explorar directorio completo <ArrowRight size={20} />
            </button>
          </div>
        </div>
      </section>

      {/* Footer Institucional Premium */}
      <footer className="bg-[#010a17] text-slate-400 py-20 border-t-[6px]" style={{ borderColor: colors.accentGold }}>
        {/* Decorative footer glow & stripes */}
        <div className="absolute top-0 right-1/4 w-96 h-96 rounded-full filter blur-[200px] opacity-20 pointer-events-none" style={{ backgroundColor: colors.primaryDark }}></div>
        <div className="absolute inset-0 stripes-pattern opacity-[0.05] pointer-events-none"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid md:grid-cols-12 gap-12 lg:gap-16">
            {/* Columna 1 - Info */}
            <div className="md:col-span-5">
              <div className="flex items-center gap-5 mb-8">
                {/* Logo Generado con CSS/Iconos para fondo oscuro */}
                <div className="h-16 w-16 rounded-full border-2 border-[#FFB703] shadow-[0_0_20px_rgba(255,183,3,0.3)] bg-gradient-to-br from-[#0A2A43] to-[#E67E22] flex items-center justify-center relative overflow-hidden">
                  <div className="absolute inset-0 stripes-pattern opacity-30"></div>
                  <Sun size={34} className="text-[#FFB703] absolute -top-2 -right-2 opacity-60" />
                  <Building size={28} className="text-white relative z-10 drop-shadow-md mt-2" />
                </div>
                <span className="font-bold text-white text-xl leading-tight uppercase tracking-wider">Junta Comunal<br/><span style={{ color: colors.accentGold }}>Mendoza</span></span>
              </div>
              <p className="text-base text-slate-400 mb-8 leading-relaxed max-w-sm font-light">
                Trabajando día a día por el bienestar, la seguridad y el progreso de nuestro corregimiento y su gente.
              </p>
              <div className="flex gap-4">
                {/* Redes sociales placeholders */}
                {[1, 2, 3].map((i) => (
                  <div key={i} className="h-12 w-12 rounded-full glass-modern !bg-white/5 border border-white/10 flex items-center justify-center hover:!bg-[#E67E22] hover:text-white cursor-pointer transition-all hover:-translate-y-1 shadow-sm">
                    <div className="w-4 h-4 bg-current rounded-sm opacity-80"></div>
                  </div>
                ))}
              </div>
            </div>

            {/* Columna 2 - Links */}
            <div className="md:col-span-3">
              <h4 className="text-white font-extrabold mb-8 uppercase tracking-widest text-sm border-l-2 pl-4 drop-shadow" style={{ borderColor: colors.accentGold }}>Enlaces Rápidos</h4>
              <ul className="space-y-4 text-sm font-medium">
                <li><a href="#inicio" className="hover:text-[#D4AF37] transition-colors flex items-center gap-2"><ChevronRight size={14} style={{ color: colors.accentOrange }}/> Inicio</a></li>
                <li><a href="#nosotros" className="hover:text-[#D4AF37] transition-colors flex items-center gap-2"><ChevronRight size={14} style={{ color: colors.accentOrange }}/> Sobre Nosotros</a></li>
                <li><a href="#tramites" className="hover:text-[#D4AF37] transition-colors flex items-center gap-2"><ChevronRight size={14} style={{ color: colors.accentOrange }}/> Solicitudes</a></li>
                <li><a href="#emprendedores" className="hover:text-[#D4AF37] transition-colors flex items-center gap-2"><ChevronRight size={14} style={{ color: colors.accentOrange }}/> Emprendedores</a></li>
                <li><a href="#transparencia" className="hover:text-[#D4AF37] transition-colors flex items-center gap-2"><ChevronRight size={14} style={{ color: colors.accentOrange }}/> Transparencia</a></li>
              </ul>
            </div>

            {/* Columna 3 - Contacto */}
            <div className="md:col-span-4" id="contacto">
              <h4 className="text-white font-extrabold mb-8 uppercase tracking-widest text-sm border-l-2 pl-4 drop-shadow" style={{ borderColor: colors.accentGold }}>Contáctenos</h4>
              <ul className="space-y-6 text-sm">
                <li className="flex items-start gap-4 group">
                  <div className="glass-modern !bg-white/5 p-2.5 rounded-xl mt-0.5 group-hover:!bg-[#D4AF37] group-hover:text-[#0A2A43] transition-colors border border-white/10" style={{ color: colors.accentGold }}><MapPin size={20} /></div>
                  <span className="leading-relaxed text-slate-300 font-light mt-1">Junta Comunal de Mendoza,<br/>Sede Principal.</span>
                </li>
                <li className="flex items-center gap-4 group">
                  <div className="glass-modern !bg-white/5 p-2.5 rounded-xl group-hover:!bg-[#D4AF37] group-hover:text-[#0A2A43] transition-colors border border-white/10" style={{ color: colors.accentGold }}><Phone size={20} /></div>
                  <span className="text-slate-300 font-semibold text-base">200-0000 / 200-0001</span>
                </li>
                <li className="flex items-center gap-4 group">
                  <div className="glass-modern !bg-white/5 p-2.5 rounded-xl group-hover:!bg-[#D4AF37] group-hover:text-[#0A2A43] transition-colors border border-white/10" style={{ color: colors.accentGold }}><Mail size={20} /></div>
                  <span className="break-all text-slate-300 font-medium">jcmendoza@gmail.com</span>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-white/10 mt-20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500 font-medium relative z-10">
            <p>&copy; 2026 Junta Comunal de Mendoza. Todos los derechos reservados.</p>
            <p className="flex items-center gap-2 glass-modern !bg-white/5 px-4 py-2 rounded-full border border-white/10">
              Representante: <span className="text-white font-bold tracking-wide">H.R. Ismael Martínez</span>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}